import React from 'react'
import { CartForm } from '../components/cart-form'
import { NewCartForm } from '../components/old-cart-form'

export const CartPage: React.FC = () => <CartForm />

export const NewCartpage : React.FC = () => <NewCartForm />